export enum CompanyType {
	UNKNOWN = 'UNKNOWN',
	DENTIST = 'DENTIST',
	LAB = 'LAB'
}
